import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Modal, Table, Avatar, Row, Col, Tooltip, Icon, Button,
} from 'antd';
import axios from 'axios';

import ImageModal from '../../UploadPrescriptionIMG/ImageModal';
import {
    SET_CAREFILL_PRESCRIPTIONS,
    ADD_CAREFILL_PRESCRIPTIONS,
    DELETE_CAREFILL_PRESCRIPTION,
} from '../../../ActionTypes/ActionTypes';

const { Column } = Table;

class CarefillPrescriptionModal extends Component {
    state = {
        visibleImage: false,
        url: '',
        selectedRowKeys: [],
    }

    componentDidMount = () => {
        const { id, setCarefillPrescription } = this.props;
        // TODO: make the call
        axios({
            method: 'get',
            url: `/carefills/carefill_p_prescription.json?carefill_id=${id}`,
            headers: { Authorization: sessionStorage.getItem('jwtToken') },
        })
            .then((response) => {
                this.setState({
                    refills: response.data,
                    loading: false,
                });
                console.log(response.data);
                // TODO: set it to redux store
                setCarefillPrescription(response.data);
            });
    }

    onSelectChange = (selectedRowKeys) => {
        this.setState({ selectedRowKeys },
            () => console.log(selectedRowKeys));
    }

    showImageModal = (link) => {
        this.setState({
            visibleImage: true,
            url: link,
        });
    }

    handleImageCancel = () => {
        this.setState({
            visibleImage: false,
        });
    }

    linkPrescription = () => {
        // TODO: make the call for linking prescriptions
        const linkedPrescriptions = this.handleLinking();
        const { linkCarefillPrescriptions, p_prescriptions_url } = this.props;
        // eslint-disable-next-line
        linkedPrescriptions.map((lp) => {
            axios({
                method: 'post',
                url: '/carefill_p_prescriptions.json',
                headers: { Authorization: sessionStorage.getItem('jwtToken') },
                data: {
                    carefill_p_prescription: lp,
                },
            })
                .then((response) => {
                    this.setState({
                        loading: false,
                    });
                    console.log(response.data);
                    // TODO: set it to redux store
                    const p_prescription = p_prescriptions_url.filter(url => Number(url.id) === Number(lp.p_prescription_id))[0];

                    linkCarefillPrescriptions(p_prescription);
                });
        });
    }

    handleLinking = () => {
        const { selectedRowKeys } = this.state;
        const { id } = this.props;
        const linkedPrescriptions = [];

        selectedRowKeys.map(skrk => (
            linkedPrescriptions.push(
                {
                    carefill_id: id,
                    p_prescription_id: skrk,
                },
            )
        ));
        return linkedPrescriptions;
    }

    deletePrescriptionLink = (prescription_id) => {
        const { deleteCarefillPrescription, id } = this.props;
        // TODO: delete prescription from redux
        axios({
            method: 'delete',
            url: `/carefill_p_prescriptions/delete_link_prescription?carefill_id=${id}&p_prescription_id=${prescription_id}`,
            headers: { Authorization: sessionStorage.getItem('jwtToken') },
        })
            .then(() => {
                this.setState({
                    loading: false,
                });
                // TODO: set it to redux store
                deleteCarefillPrescription(prescription_id);
            });
    }

    render() {
        const {
            selectedRowKeys, visibleImage, url, loading,
        } = this.state;
        const {
            visible, onCancel, p_prescriptions_url, carefill_prescriptions,
        } = this.props;

        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };

        return (
            <Modal
                visible={visible}
                title="Link the Prescription"
                width="80%"
                style={{ textAlign: 'center', fontSize: '1.2em' }}
                onCancel={onCancel}
                footer={null}
            >
                <Row type="flex" justify="space-around">
                    <Col span={8}>
                        <h5 style={{ textAlign: 'center' }}>Linked Prescription</h5>
                        <hr width="100" />
                        <div>
                            <Table
                                pagination={false}
                                dataSource={carefill_prescriptions}
                                rowKey="id"
                                loading={loading}
                            >
                                <Column
                                    title="P ID"
                                    align="center"
                                    dataIndex="id"
                                />
                                <Column
                                    title="Photo"
                                    align="center"
                                    render={
                                        record => (
                                            <Avatar
                                                onClick={() => this.showImageModal(record.photo_link)}
                                                style={{ width: 100, height: 100, cursor: 'pointer' }}
                                                src={record.photo_link}
                                            />
                                        )
                                    }
                                />
                                <Column
                                    title="Actions"
                                    align="center"
                                    render={
                                        record => (
                                            <Tooltip placement="top" title="Print Refill">
                                                <span onClick={() => this.deletePrescriptionLink(record.id)} role="button">
                                                    <a><Icon type="delete" style={{ fontSize: 20, color: 'red' }} /></a>
                                                </span>
                                            </Tooltip>
                                        )
                                    }
                                />
                            </Table>
                        </div>
                    </Col>

                    <Col span={8}>
                        <h5 style={{ textAlign: 'center' }}>All Prescriptions</h5>
                        <hr width="100" />
                        <div>
                            <Table
                                pagination={false}
                                dataSource={p_prescriptions_url}
                                rowSelection={rowSelection}
                                rowKey="id"
                            >
                                <Column
                                    title="ID"
                                    dataIndex="id"
                                />
                                <Column
                                    title="Photo url"
                                    render={
                                        record => (
                                            <Avatar
                                                onClick={() => this.showImageModal(record.photo_link)}
                                                style={{ width: 100, height: 100, cursor: 'pointer' }}
                                                src={record.photo_link}
                                            />
                                        )
                                    }
                                />
                            </Table>

                            <div style={{ marginTop: 30 }}>
                                <Button onClick={this.linkPrescription} type="primary">Link</Button>
                            </div>

                        </div>
                    </Col>
                </Row>

                {
                    visibleImage
                        ? (
                            <ImageModal
                                visible={visibleImage}
                                url={url}
                                handleCancel={this.handleImageCancel}
                            />
                        )
                        : null
                }


            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    carefill_prescriptions: state.AppState.carefill_prescriptions,
    p_prescriptions_url: state.AppState.p_prescriptions_url,
});

const mapDispatchToProps = dispatch => ({
    setCarefillPrescription: carefill_prescriptions => dispatch({ type: SET_CAREFILL_PRESCRIPTIONS, payload: { carefill_prescriptions } }),
    linkCarefillPrescriptions: linkedPrescriptions => dispatch({ type: ADD_CAREFILL_PRESCRIPTIONS, payload: { linkedPrescriptions } }),
    deleteCarefillPrescription: idToDelete => dispatch({ type: DELETE_CAREFILL_PRESCRIPTION, payload: { idToDelete } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(CarefillPrescriptionModal);



// WEBPACK FOOTER //
// ./src/component/FetchOrderList/CarefillPrescriptionLinking/CarefillPrescriptionModal.js